
import { mapCollection } from '../../utils/collection.utils';
import { ResearchUnit } from '../research-unit';

export class ResearchUnitBuilder {
  static fromJson(json) {
    return (json)
      ? new ResearchUnit(
        json.hash,
        json.name,
        json.code
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(ResearchUnitBuilder.fromJson, list);
  }
}
